<template>
  <div class="bb-bank-form">
    <transition name="fade" appear>
      <loader-fly v-if="loader"/>
    </transition>
    <div class="bb-bank-form-item">
      <label class="bb-bank-form-item__label" for="name">Name</label>
      <input class="bb-bank-form-item__input bb-input" id="name" type="text" v-model="details.name" v-autofocus
             :class="{'bb-bank-form-item__input_failed' : errors.name}" @keyup.esc="cancelEdit()">
      <span v-if="errors.name" class="bb-bank-form-item__input_error">{{errors.name}}</span>
    </div>
    <div class="bb-bank-form-item bb-bank-form-item_details">
      <label class="bb-bank-form-item__label bb-bank-form-item__label_details" for="details">Details</label>
      <textarea class="bb-bank-form-item__input bb-bank-form-item__input_details" id="details"
                v-model="details.details"
                :class="{'bb-bank-form-item__input_failed' : errors.details}"
                @keyup.esc="cancelEdit()"/>
      <span v-if="errors.details" class="bb-bank-form-item__input_error">{{errors.details}}</span>
    </div>
    <div class="bb-bank-form-item">
      <label class="bb-bank-form-item__label">IBAN</label>
    </div>
    <div class="bb-bank-form-item bb-bank-form-item_number">
      <label class="bb-bank-form-item__label bb-bank-form-item__label_iban" for="AED">AED</label>
      <input class="bb-bank-form-item__input bb-input" id="AED" type="text" v-model="details.iban.aed"
             @keyup.enter="saveFrom()" :class="{'bb-bank-form-item__input_failed' : errors.aed}"
             @keyup.esc="cancelEdit()">
      <span v-if="errors.aed" class="bb-bank-form-item__input_error">{{errors.aed}}</span>
    </div>
    <div class="bb-bank-form-item bb-bank-form-item_with-rate">
      <div class="bb-bank-form-item bb-bank-form-item_number">
        <label class="bb-bank-form-item__label bb-bank-form-item__label_iban" for="USD">USD</label>
        <input class="bb-bank-form-item__input bb-input" id="USD" type="text" v-model="details.iban.usd"
               @keyup.enter="saveFrom()" @keyup.esc="cancelEdit()">
      </div>
      <div class="bb-bank-form-item bb-bank-form-item_number">
        <input class="bb-bank-form-item__input bb-input" id="USDRate" type="text" v-model="details.currencyRates.usd"
               @keyup.enter="saveFrom()" @keyup.esc="cancelEdit()">
      </div>
    </div>
    <div class="bb-bank-form-item bb-bank-form-item_with-rate">
      <div class="bb-bank-form-item bb-bank-form-item_number">
        <label class="bb-bank-form-item__label bb-bank-form-item__label_iban" for="EUR">EUR</label>
        <input class="bb-bank-form-item__input bb-input" id="EUR" type="text" v-model="details.iban.eur"
               @keyup.enter="saveFrom()" @keyup.esc="cancelEdit()">
      </div>
      <div class="bb-bank-form-item bb-bank-form-item_number">
        <input class="bb-bank-form-item__input bb-input" id="EURRate" type="text" v-model="details.currencyRates.eur"
               @keyup.enter="saveFrom()" @keyup.esc="cancelEdit()">
      </div>
    </div>
    <div class="bb-bank-form-item bb-bank-form-item_with-rate">
      <div class="bb-bank-form-item bb-bank-form-item_number">
        <label class="bb-bank-form-item__label bb-bank-form-item__label_iban" for="RUB">RUB</label>
        <input class="bb-bank-form-item__input bb-input" id="RUB" type="text" v-model="details.iban.rub"
               @keyup.enter="saveFrom()" @keyup.esc="cancelEdit()">
      </div>
      <div class="bb-bank-form-item bb-bank-form-item_number">
        <input class="bb-bank-form-item__input bb-input" id="RUBRate" type="text" v-model="details.currencyRates.rub"
               @keyup.enter="saveFrom()" @keyup.esc="cancelEdit()">
      </div>
    </div>
    <div class="bb-bank-form-btn-wrapper">
      <button class="bb-bank-form-btn-wrapper__btn bb-bank-form-btn-wrapper__btn_cancel bb-button"
              @click="cancelEdit()">
        CANCEL
      </button>
      <button class="bb-bank-form-btn-wrapper__btn bb-button" @click="saveFrom()">SAVE</button>
    </div>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import validateNum from '@/mixin/validateNum'

export default {
  name: 'BankDetailsForm',
  props: ['bankDetails', 'editable', 'loader'],
  mixins: [validateNum],
  components: {
    LoaderFly
  },
  data () {
    return {
      errors: {
        name: '',
        details: '',
        aed: ''
      },
      details: {
        name: '',
        details: '',
        currencyRates: {
          usd: 3.67,
          eur: 3.9,
          rub: 1,
        },
        iban: {
          aed: '',
          usd: '',
          eur: '',
          rub: '',
        }
      }
    }
  },
  methods: {
    saveFrom () {
      if (this.checkInputs()) {
        return
      }
      const item = this.details
      const index = this.editable
      this.$emit('save', item, index)
    },
    cancelEdit () {
      this.$emit('cancel')
    },
    checkInputs () {
      let haveError = false
      const eurRate = this.details.currencyRates.eur
      this.details.currencyRates.eur = this.validateNum(eurRate)
      const usdRate = this.details.currencyRates.usd
      this.details.currencyRates.usd = this.validateNum(usdRate)
      if (!this.details.name) {
        this.errors.name = 'mandatory field'
        haveError = true
      } else {
        this.errors.name = ''
      }
      if (!this.details.details) {
        this.errors.details = 'mandatory field'
        haveError = true
      } else {
        this.errors.details = ''
      }
      if (!this.details.iban.aed) {
        this.errors.aed = 'mandatory field'
        haveError = true
      } else {
        this.errors.aed = ''
      }

      return haveError
    }
  },
  beforeMount () {
    Object.assign(this.details, this.bankDetails)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-bank {
    @include global-font;

    &-form {
      display: flex;
      flex-direction: column;
      width: 468px;
      margin-top: 24px;

      &-item {
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &_with-rate {
          display: grid;
          grid-template-columns: 1fr 75px;
          grid-gap: 25px;
          margin: 0;
        }

        &_number {
          margin-bottom: 13px;
        }

        &_details {
          margin-bottom: 25px;
        }

        &__label {
          font-size: 14px;
          line-height: 17px;
          min-width: 72px;

          &_details {
            margin-bottom: auto;
          }

          &_iban {
            font-size: 12px;
            line-height: 14px;
            font-weight: lighter;
          }
        }

        &__input {
          @include global-font-light;
          position: relative;
          width: 100%;
          height: 42px;
          padding: 8px 11px;
          border: 1px solid transparent;
          background-color: $color-white;
          font-size: 14px;
          line-height: 17px;
          border-radius: 5px;

          &_details {
            resize: none;
            min-height: 137px;
          }

          &_failed {
            border: 1px solid $color-red-orange;
          }

          &_error {
            position: absolute;
            right: 12px;
            color: $color-red-orange;
            font-size: 11px;
            line-height: 13px;
          }
        }
      }

      &-btn-wrapper {
        display: flex;
        margin-left: auto;

        &__btn {
          width: 73px;
          border: 2px solid $color-accent;
          box-sizing: border-box;
          margin-top: 21px;

          &_cancel {
            margin-right: 20px;
            color: $color-accent;
            background-color: transparent;
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Forms/BankDetailsForm.vue